<template>
  <div>
    <lcontainer>
      <lcontainer class="mb-4">
        <div
          class="heading flex flex-row items-center justify-between py-2 px-8"
        >
          <div>
            <div class="page my-4 text-white">
              {{ getTenantModule.course }}
            </div>
          </div>
          <div>
            <img :src="require('../../../assets/tenant_image.png')" alt="" />
          </div>
        </div>
      </lcontainer>
      <div class="py-4 px-8">
        <lCrumbs :breadcrumb="breadcrumbItems" />
        <div class="flex justify-between">
          <page-header class="">Module Information</page-header>
          <lms-button
            class="block mr-2"
            @click="
              $router.push({
                name: 'tenant-lesson-create',
                params: { id: $route.params.id },
              })
            "
            >Add Lesson</lms-button
          >
        </div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/2 items-center form-row  px-4">
            <div class="flex flex-row justify-between my-4">
              <div class=" font-semibold">Module Title:</div>
              <div>
                <p>{{ getTenantModule.title }}</p>
              </div>
            </div>
            <div class="flex flex-row justify-between my-4">
              <div class=" font-semibold">Module Description:</div>
              <div>
                <p>{{ getTenantModule.description }}</p>
              </div>
            </div>
            <div class="flex flex-row justify-between my-4">
              <div class=" font-semibold">Module Duration:</div>
              <div>
                <p>{{ getTenantModule.duration }}</p>
              </div>
            </div>
          </div>
        </div>
        <page-header class="py-2">All Module Lessons</page-header>
        <div class="flex flex-wrap">
          <div
            v-for="(lesson, i) in searchlessons"
            :key="i"
            class="w-full md:w-1/3 lg:w-1/4 my-2"
          >
            <lesson-card class="" :lesson="lesson"></lesson-card>
          </div>
        </div>
        <div />
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
//const AWS = require('aws-sdk');
export default {
  components: {
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    LessonCard: () => import("@/components/tenant/lesson-card"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  data() {
    return {
      form: {},
      singleModule: {},
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/courses",
          text: "All Courses",
        },
        {
          disabled: true,
          to: `/tenant/courses/view/${this.$route.params.id}`,
          text: "Single Course",
        },
        {
          disabled: true,
          to: `/tenant/courses/${this.$route.params.id}/modules`,
          text: "Modules",
        },
        {
          disabled: true,
          to: `#`,
          text: "Single Module",
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["getTenantModule", "getTenantModuleLessons"]),
    searchlessons() {
      return this.getTenantModuleLessons.sort(
        (a, b) => a.lesson_number > b.lesson_number
      );
    },
  },
  created() {
    this.updateLoader(true);
    this.fetchSingleTenantModule({
      id: this.$route.params.module,
    });
    this.fetchTenantModuleLessons({
      id: this.$route.params.module,
    });
    this.updateLoader(false);
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["fetchSingleTenantModule", "fetchTenantModuleLessons"]),
    // navigate() {
    //   this.$router.push(`/tenants/courses/${this.$route.params.id}/modules`);
    // },
  },

    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.form-row {
  .modal-title {
    font-size: 24px;
    color: color(lms-admin);
  }

  .modal-field {
    color: color(lms-admin);
    margin-right: 4rem;
  }
  .close {
    background-color: #c2454b;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    font-size: 12px;
    top: -17px;
    z-index: 2;
    right: 11px;
  }
  z-index: 1;
  // max-width: 500px;
}
</style>
